/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {SeverityEnum} from '../../../../api/generic/contracts/severity.enum';
import {ClaimDetailModel} from '../../../../api/ms-claims/contracts/claim-detail.model';
import {ToastWrapperService} from '../../../../shared/utils/toast-wrapper-service/toast-wrapper-service';

@Injectable({
    providedIn: 'root'
})
export class HandlingUnitValidationService {

    constructor(private toast: ToastWrapperService) {
    }

    handlingUnitValidationErrorsToast = (claimDetail: ClaimDetailModel): void => {
        const errors = claimDetail.claimPositions.filter(position =>
                position.handlingUnitValidation && position.handlingUnitValidation.severity === SeverityEnum.ERROR);

        if (errors.length > 0) {
            this.toast.error(this.errorToastMessage(claimDetail.material.number), 'Error');
        }
    };

    private errorToastMessage(materialNumber: string): string {
        return ` <strong>Please check your entries</strong> for one or more HUs with material ${materialNumber}`;
    }
}
